import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import RegistrationForm from './RegistrationForm';

ReactDOM.render(
  <React.StrictMode>
    <RegistrationForm
        l10n={window.wpcrL10n}
        settings={window.wpcrSettings}
        load={window.wpcrLoad} />
  </React.StrictMode>,
  document.getElementById('wpcr-registration-form-root')
);
